import { Controller } from "@hotwired/stimulus"

// Dispara evento custom quando o form de "Sincronizar agora" submete,
// pra que o sync_status_controller comece a fazer polling.
export default class extends Controller {
  start() {
    document.dispatchEvent(new CustomEvent("processos:sync-started"))
  }
}
